import React from 'react'
import Hero from './Hero'
import About from './About'
import Numbers from './Numbers'
import Services from './Services'
import Features from './Features'
import Portfolio from './Portfolio'
import Pricing from './Pricing'
import Questions from './Questions'
import Team from './Team'
import Action from './Action'
import Testimonials from './Testimonials'
import Posts from './Posts'
import Contact from './Contact'
import Footer from './Footer'

const HomePage = () => {
    return (
        <>
        <Hero />
        <About />
        <Numbers />
        <Services />
        <Features />
        <Portfolio />
        <Pricing />
        <Questions />
        <Team />
        <Action />
        <Testimonials />
        <Posts />
        <Contact />
        <Footer />
        </>
    )
}

export default HomePage